import { useCallback } from 'react';
import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { DEFAULT_EP_ID } from '../../constants/DEFAULT';

interface TradeState {
  data: any;
  mutate: (data: any) => void;
  reset: () => void;
}

export const useZTradeStore = create<TradeState>()(
  persist(
    (set) => ({
      data: { ep_id: DEFAULT_EP_ID },
      mutate: (value) => set(() => ({ data: value })),
      reset: () => set({ data: { ep_id: DEFAULT_EP_ID } }),
    }),
    {
      name: 'trade-storage',
      storage: createJSONStorage(() => localStorage),
      version: 1,
    }
  )
);

export default function useTradeStore(initData?: any, reset?: boolean) {
  const data = useZTradeStore((state) => state.data);
  const mutate = useZTradeStore((state) => state.mutate);

  // 데이터 속성 직접 접근 (useMemo 생략)
  const ep_id = data?.ep_id || 2;
  const chart_id = data?.chart_id;
  const pairs = data?.pairs;
  const dp = data?.dp || 2;
  const dp2 = data?.dp2 || 2;
  const unit = data?.unit || 2;

  // mutate 함수를 useCallback으로 최적화
  const handleMutate = useCallback(
    async (value: any) => {
      try {
        await mutate(value); // 비동기 호출
      } catch (error) {
        console.error('Error mutating data:', error);
      }
    },
    [mutate]
  );

  return {
    data,
    ep_id,
    chart_id,
    pairs,
    dp,
    dp2,
    unit,
    mutate: handleMutate,
  };
}
